import React from "react";
import "antd/dist/reset.css";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { errorRoutes } from "./routes/ErrorRoutes";
import { authRoutes } from "./routes/AuthRoutes";
import AuthLayout from "./layout/auth/AuthLayout";
import ErrorLayout from "./layout/error/ErrorLayout";
import PersistLoginContext from "./context/PersistLoginContext";
import AuthContext from "./context/AuthContext";
import DashboardLayout from "./layout/dashboard/DashboardLayout";
import { IRoutesModel } from "./models/routes";
import { dashboardRoutes } from "./routes/DashboardRoutes";

export let navigation: any = "";

function App() {
  const nav = useNavigate();
  navigation = nav;
  const renderRoutes = (routes: IRoutesModel[]) =>
    routes.map(({ path, element, children, isShow }) => {
      return (
        <Route key={path} path={path} element={element}>
          {children && renderRoutes(children)}
        </Route>
      );
    });
  return (
    <div className="bg-gray-200 min-h-screen">
      <Routes>
        <Route path="/error" element={<ErrorLayout />}>
          {errorRoutes?.map(({ path, element }) => (
            <Route path={path} element={element} />
          ))}
        </Route>
        <Route path="/auth" element={<AuthLayout />}>
          {authRoutes?.map(({ path, element }) => (
            <Route path={path} element={element} />
          ))}
        </Route>

        <Route path="/" element={<Navigate replace to="dashboard/trips" />} />
        <Route element={<PersistLoginContext />}>
          <Route element={<AuthContext />}>
            <Route
              path="/"
              element={<Navigate replace to="dashboard/trips" />}
            />
            <Route path="/dashboard" element={<DashboardLayout />}>
              {renderRoutes(dashboardRoutes)}
            </Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
